"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = require("styled-components");
const use_media_1 = require("use-media");
const popover_1 = require("../styles/popover");
const utils_1 = require("../utils");
const machineTypes_1 = require("../utils/machineTypes");
const popover_content_1 = __importDefault(require("./popover-content"));
const Popover = ({ onClose, onRouting, store, state }) => {
    const theme = (0, styled_components_1.useTheme)();
    const isMobile = (0, use_media_1.useMedia)({ maxWidth: theme.breakpoint.tablet });
    if (!(store === null || store === void 0 ? void 0 : store.data))
        return null;
    const { data, status } = store;
    const openNew = [machineTypes_1.MachineTypes.OPEN_NEW_ITEM, machineTypes_1.MachineTypes.OPEN_NEW_LOYALTY].includes(state.value);
    const isOpen = [machineTypes_1.MachineTypes.OPEN_CART, machineTypes_1.MachineTypes.OPEN_NEW_ITEM, machineTypes_1.MachineTypes.OPEN_EMPTY, machineTypes_1.MachineTypes.OPEN_NEW_LOYALTY].includes(state.value);
    if ((0, utils_1.shouldHidePopover)(store) || (isMobile && !openNew))
        return null;
    return ((0, jsx_runtime_1.jsx)(popover_1.FixedParent, { openNew: openNew, children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: popover_1.DURATION, mountOnEnter: true, unmountOnExit: true, appear: true, children: (0, jsx_runtime_1.jsx)(popover_1.ContainerStyled, { children: (0, jsx_runtime_1.jsx)(popover_content_1.default, { data: data, status: Number(status), onRouting: onRouting, onClose: onClose, stateValue: state.value }) }) }) }));
};
exports.default = Popover;
